(function () {
  'use strict';

  angular.module('app').component('addBookingItemToGuest', addBookingItemToGuest());

  function addBookingItemToGuest() {
    return {
      bindings: {
        item: '<',
        onSavedItem: '&',
        onCanceledItem: '&',
      },
      controller: AddBookingItemToGuestComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bookings/booking-guests/add-booking-item-to-guest/add-booking-item-to-guest.component.html',
    };
  }

  AddBookingItemToGuestComponent.$inject = ['ModalWindowConfirmService', 'GuestService'];

  function AddBookingItemToGuestComponent(ModalWindowConfirmService, GuestService) {
    const vm = this;

    let modalParams = {
      mode: 'danger',
      preventModalClose: true,
      title: 'CHECK_IN_IS_NOT_ALLOW_HAS_CHECKED_IN',
      confirmButtonLabel: 'ACCEPT',
    };

    // Methods
    vm.saveAddBookingItemToGuest = saveAddBookingItemToGuest;
    vm.checkAllGuests = checkAllGuests;
    vm.checkGuest = checkGuest;
    vm.cancel = cancel;

    vm.$onInit = function () {
      vm.bookingItemServiceItem = vm.item.bookingItemServiceItem;
      vm.bookingItem = vm.item.bookingItem;
      vm.guests = angular.copy(vm.item.booking.guests);
      vm.bookingItemName = vm.item.bookingItem.detail.name;
      vm.bookingItemServiceItemName = vm.bookingItem.based_on_service_items
        ? vm.item.bookingItemServiceItem.service_item.name
        : '';
      vm.isBaseOnServiceItem = vm.item.bookingItem.based_on_service_items;

      selectedGuests(vm.guests);
    };

    function checkAllGuests() {
      let hasItems = false;
      vm.guests.forEach((guest) => {
        let result = hasCheckedIn(guest);

        if (!vm.allGuestsChecked && result) {
          guest.selected = !vm.allGuestsChecked;
        } else {
          guest.selected = vm.allGuestsChecked;
        }

        hasItems = result ? result : hasItems;
      });

      if (hasItems && !vm.allGuestsChecked) ModalWindowConfirmService.open(modalParams);

      validateCheckedGuests();
    }

    function checkGuest(isChecked, guest) {
      if (!isChecked && hasCheckedIn(guest)) {
        guest.selected = !isChecked;
        ModalWindowConfirmService.open(modalParams);
        return;
      }

      guest.selected = isChecked;

      validateCheckedGuests();
    }

    function hasCheckedIn(guest) {
      if (vm.isBaseOnServiceItem)
        return guest.checked_in_service_items.includes(vm.bookingItemServiceItem.id);

      return guest.checked_in_booking_items.includes(vm.bookingItem.id);
    }

    function validateCheckedGuests() {
      vm.allGuestsChecked = vm.guests.every((guest) => guest.selected === true);

      vm.isBaseOnServiceItem ? addBookingItemServiceItemToGuest() : addBookingItemToGuest(); // TODO: ???
    }

    function addBookingItemToGuest() {
      vm.guests.forEach((guest) => {
        let isBookingItemAdded = guest.booking_item_ids.includes(vm.bookingItem.id);
        if (guest.selected && !isBookingItemAdded) {
          guest.booking_item_ids = guest.booking_item_ids || [];
          guest.booking_item_ids.push(vm.bookingItem.id);
        } else {
          if (!guest.selected && isBookingItemAdded) {
            guest.booking_item_ids.splice(
              guest.booking_item_ids.map((id) => id).indexOf(vm.bookingItem.id),
              1
            );
          }
        }
      });
    }

    function addBookingItemServiceItemToGuest() {
      vm.guests.forEach((guest) => {
        let isServiceItemAdded = guest.booking_item_service_item_ids.includes(
          vm.bookingItemServiceItem.id
        );
        if (guest.selected && !isServiceItemAdded) {
          guest.booking_item_service_item_ids = guest.booking_item_service_item_ids || [];
          guest.booking_item_service_item_ids.push(vm.bookingItemServiceItem.id);
        } else {
          if (!guest.selected && isServiceItemAdded) {
            guest.booking_item_service_item_ids.splice(
              guest.booking_item_service_item_ids
                .map((id) => id)
                .indexOf(vm.bookingItemServiceItem.id),
              1
            );
          }
        }
      });
    }

    function selectedGuests(guests) {
      guests.forEach((guest) => {
        if (vm.bookingItem.based_on_service_items) {
          vm.bookingItem.booking_item_service_items.forEach((serviceItem) => {
            if (vm.bookingItemServiceItem.id === serviceItem.id) {
              guest.selected = vm.bookingItemServiceItem.guest_ids.includes(guest.id);
            }
          });
        } else {
          guest.selected = vm.bookingItem.guest_ids.includes(guest.id);
        }
      });

      validateCheckedGuests();
    }

    function saveAddBookingItemToGuest() {
      vm.sendingForm = true;

      GuestService.addBookingItemToGuest(
        vm.guests,
        vm.bookingItem,
        vm.bookingItemServiceItem,
        vm.isBaseOnServiceItem
      ).then(function (data) {
        vm.onSavedItem({ item: data.response });

        vm.sendingForm = false;
      });
    }

    function cancel() {
      vm.onCanceledItem();
    }
  }
})();
